import React from 'react';
import { Event } from '../../../../stores/events';
import style from './styles.module.scss';

const EventImage: React.FC<{ record: Event }> = React.memo(({ record }) => {
    const enTranslation = record.translations.find((t) => t.language === 'en');
    const imageUrl = enTranslation?.image || '';

    return (
        <div className={style.image_container}>
            <img src={imageUrl} alt="" className={style.thumbnail} />
        </div>
    );
});
EventImage.displayName = 'EventImage';

export default EventImage;
